import actions from "@/store/order/actions";
import mutations from "@/store/order/mutations";
import state from "@/store/order/state";
export default {
    actions,
    mutations,
    state
}